import React, {
  useEffect,
  useState,
  useRef
} from 'react'
import * as PIXI from 'pixi.js'

export default props => {

  const animationRef = useRef()
  
  useEffect(() => {

    if(animationRef.current) {
      
      const w = animationRef.current.offsetWidth
      const h = animationRef.current.offsetHeight
      const confetticount = 500
          
      const app = new PIXI.Application({         
        resizeTo: animationRef.current,
        backgroundAlpha: 0
      })
      animationRef.current.appendChild(app.view)
      app.renderer.background.alpha = 0

      const color = [
        0xffffff, 
        0xff2a5c, 
        0xe4ff2a, 
        0xa62aff, 
        0x3df2da, 
        0xff2a9c, 
        0x2aff9f
      ]
      const xAdd = []
      const graphics = []
      const scale = []

      for (let i = 0; i < confetticount; i++) {

        const colornum = i % color.length
        scale.push(((Math.floor(Math.random() * 4) + 8) / 15))
        const x = Math.floor(Math.random() * w) + 20 
        const y = Math.floor(Math.random() * h)
        xAdd.push(i % 2 === 0 ? 1 : -1)
        graphics.push(new PIXI.Graphics().beginFill(color[colornum], 1).drawRect(-5, -5, 10, 10))
        graphics[i].position.x = x
        graphics[i].position.y = y
        graphics[i].scale.x = scale[i]
        graphics[i].scale.y = scale[i]
        graphics[i].skew.y = i % 10 * 0.1
        graphics[i].rotation = 0.1 + ((i % 5) * 0.1)

        app.stage.addChild(graphics[i])
      }
      
      function animate() {

        requestAnimationFrame(animate)

        const skew = [0.02, 0.04, 0.06, 0.08, 0.1]
        const xPlus = [0.05, 0.1, 0.15, 0.2, 0.25]

        for (let i = 0; i < confetticount; i++) {

          let y
          let x
          const colornum = i % color.length
          graphics[i].clear()
          graphics[i].beginFill(color[colornum], 1).drawRect(-5, -5, 10, 10)
          if(graphics[i].y > h) {
            y = -10
            x = Math.floor(Math.random() * w) + 10
          } else {
            y = graphics[i].y + 0.2 + ((i % 5) * 0.1)
          }
          if (graphics[i].x > w - 10) {
            xAdd[i] = -1
          } else if (graphics[i].x < 10) {
            xAdd[i] = 1
          }
          if(xAdd[i] === -1) {
            x = graphics[i].x - xPlus[i % 5]
          } else {
            x = graphics[i].x + xPlus[i % 5]
          }
          graphics[i].scale.x = scale[i]
          graphics[i].scale.y = scale[i]
          graphics[i].position.x = x
          graphics[i].position.y = y
          graphics[i].skew.y += i % 2 === 0 ? skew[i % 5] : skew[i % 5] * -1
          graphics[i].rotation += i % 2 === 0 ? (0.01 + ((i % 5) * 0.01)) : (0.01 + ((i % 5) * -0.01))
        }
      }

      animate()
    } 

  }, [animationRef.current])
  
  return <div 
    className="result"
    ref={ animationRef }
  />
}